import script from "./pageCenter.vue?vue&type=script&setup=true&lang=js"
export * from "./pageCenter.vue?vue&type=script&setup=true&lang=js"

import "./pageCenter.vue?vue&type=style&index=0&id=003f9559&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-003f9559"]])

export default __exports__